import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/poe1-home'
  },
  {
    path: '/poe2-standard',
    name: 'PoE2Standard',
    component: () => import('@/views/PoE2Standard.vue'),
    meta: {
      title: 'PoE 2-标准'
    }
  },
  {
    path: '/poe2-vaal',
    name: 'PoE2Vaal',
    component: () => import('@/views/PoE2Vaal.vue'),
    meta: {
      title: 'PoE2-VAAL 赛季'
    }
  },
  {
    path: '/poe1-home',
    name: 'PoE1Home',
    component: () => import('@/views/PoE1Home.vue'),
    meta: {
      title: 'PoE1-首页'
    }
  },
  {
    path: '/poe1-standard',
    name: 'PoE1Standard',
    component: () => import('@/views/PoE1Standard.vue'),
    meta: {
      title: 'PoE1-标准'
    }
  },
  {
    path: '/poe1-keepers',
    name: 'PoE1Keepers',
    component: () => import('@/views/PoE1Keepers.vue'),
    meta: {
      title: 'PoE1-KEEPERS 赛季'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
